<!--
 * @Description: 
 * @Author:  
 * @Date: 2024-09-09 09:18:17
 * @LastEditTime: 2024-09-09 17:48:08
 * @LastEditors:  
-->
<!--
 * @Description: 申请退款
 * @Author:  wang.y
-->
<template>
  <Modal v-model="modelIndex" width="530" class="login-model" @on-cancel="close" :footer-hide="true">
    <div class="container-wrapper">
      <div class="model-bg-wrapper">
        <img :src="static_img_url + 'pic/modal-bg-top.png?v=' + $store.state.imgVersion" />
        <img :src="static_img_url + 'pic/modal-bg-btm.png?v=' + $store.state.imgVersion" />
      </div>
      <div class="container-content">
        <div class="container-top">
          <div class="container-title reset-form-title">{{'恭喜您！获得赠票' | dealLanguage('Congratulations! Get a free ticket')}}</div>
          <div class="tip-warpper">
            <img :src="static_img_url + 'pic/success-icon.png?v=' + $store.state.imgVersion" />
            <p class="p1" v-if="language == 'zh'">您已成功收到 <span>{{count}}</span> 张门票，<br />可在“我的门票”页面中查看门票信息。</p>
            <p class="p1" v-if="language == 'en'">You have successfully received <span>{{count}}</span> ticket. <br />You can view the ticket information on the "My Tickets" page.</p>
          </div>
        </div>
        <div class="container-bottom ">
          <div class="btns-wrapper">
            <Button class="submit-btn" type="primary" @click="submit">{{'确认' | dealLanguage('Confirm')}}</Button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { acceptTicket } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  data() {
    return {
      modelIndex: false,
      count: 0,
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      language: (state) => state.language,
    }),
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    async submit() {
      this.modelIndex = false
      let res = await acceptTicket()
      if (res.code != 0) {
        this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
        return
      }
      this.$Message.success(this.language == 'zh' ? '成功获取门票！' : 'Tickets obtained successfully!')
      this.$router.push({
        name: 'myTickets',
      })
    },
  },
  created() {},
  mounted() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/login.styl'
.tip-warpper
  padding 90px 0
  text-align center
  img
    width 60px
    height 60px
  .p1
    font-size 16px
    color #3D3D3D
    line-height 22px
    margin-top 20px
    span
      color #C8161D
.btns-wrapper
  .submit-btn
    margin-left 0 !important
</style>
